import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { notifications } from '@mantine/notifications';
// I18n
import { useTranslation } from 'react-i18next';
import { TResponseApi } from 'shared/types';

export const remove = (
	id: string
): Promise<{
	response: TResponseApi;
}> => {
	return apiClient.delete(`/media/${id} `);
};

export const useRemovePrivateMedia = () => {
	const { t } = useTranslation();
	const { mutate, isPending: isLoading } = useMutation({
		mutationFn: remove,
		onError: (error: any) => {
			notifications.show({
				title: 'Error',
				message: t(`api.${error.type}`),
				color: 'error',
			});
		},
	});

	return { mutate, isLoading };
};
